import './index.css'
import { useState,useEffect } from 'react'
import { fetchFreeTrialDays } from '../../functions/fetchDaysLeftInTrial';

function FreeTrialBanner(){
    const [daysLeft,SetDaysLeft] = useState(' ');
    useEffect(async() => {
        const daysLeftRes = await fetchFreeTrialDays();
        SetDaysLeft(daysLeftRes);
      }, []);
    return <div className='trial-banner small-text'>
        You have {daysLeft} days left of your trial! Already loving it?<a href='/payment'>Upgrade now!</a>
    </div>
}

export default FreeTrialBanner